/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useLayoutEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, ChevronDownIcon, ChevronRightIcon, PlusIcon, TagIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import TransactionContextMenu from './TransactionContextMenu';
import BlueTransactionsDialog from './BlueTransactionsDialog';

function showBlueTransactionsInDialog(transactionIds, category) {
  const resolvedIds = Array.isArray(transactionIds) ? transactionIds : [transactionIds];
  // show dialog with passcode prompt, ask for passcode, dispatch the below in callback
  window.dispatchEvent(
    new CustomEvent('setDialog', {
      detail: {
        Component: BlueTransactionsDialog,
        props: { visible: true, transactionIds: resolvedIds, category },
      },
    }),
  );
}

/**
 * Only displays the label for whitelisted labels.
 *
 * @param {} param0
 * @returns
 */
function LabelButton({ transactionId, label, selectedTransactionIds }) {
  LabelButton.propTypes = {
    transactionId: PropTypes.string.isRequired,
    label: PropTypes.string,
    selectedTransactionIds: PropTypes.arrayOf(PropTypes.string),
  };
  LabelButton.defaultProps = {
    label: null,
    selectedTransactionIds: [],
  };

  const { t } = useTranslation();
  const approvedLabel = label?.includes('investment-');
  const category = 'deposits';
  const resolvedSelection = selectedTransactionIds && selectedTransactionIds.length > 0 ? selectedTransactionIds : [transactionId];

  return (
    <button type="button" className="inline-flex items-center justify-center text-gray-400 cursor-pointer w-auto" onClick={() => showBlueTransactionsInDialog(resolvedSelection, category)}>
      {/* REGULAR VARIANT */}

      <div className="hidden sm:block">
        {approvedLabel && label ? (
          <span className="inline-block rounded-md bg-brandBlue-100 hover:bg-brandBlue-200 px-2 py-0.5 text-xs font-medium text-brandBlue-700">
            {t(`accountDetails:${category}.labels.${label}.short`)}
          </span>
        ) : (
          // eslint-disable-next-line max-len
          <span className="inline-block rounded-md border border-gray-100 bg-white hover:bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-300">{t('accountDetails:deposits.addTag')}</span>
        )}
        <span className="sr-only">{label}</span>
      </div>

      {/* XS- BREAKPOINT VARIANT */}

      <div className="sm:hidden">
        {approvedLabel && label ? (
          <span className="inline-block items-center justify-center rounded-lg bg-brandBlue-100 hover:bg-brandBlue-200 border border-brandBlue-100 p-2 text-xs font-medium text-brandBlue-400">
            <TagIcon className="w-5 h-5" />
          </span>
        ) : (
          // eslint-disable-next-line max-len
          <span className="inline-block items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 p-2 text-xs font-medium text-gray-300">
            <PlusIcon className="w-5 h-5" />
          </span>
        )}
        <span className="sr-only">{label}</span>
      </div>
    </button>
  );
}

function showContextMenuInDialog(transactionIds) {
  const resolvedIds = Array.isArray(transactionIds) ? transactionIds : [transactionIds];
  // show dialog with passcode prompt, ask for passcode, dispatch the below in callback
  window.dispatchEvent(
    new CustomEvent('setDialog', {
      detail: {
        Component: TransactionContextMenu,
        props: { visible: true, transactionIds: resolvedIds },
      },
    }),
  );
}

function EllipsisButton({ transactionId, selectedTransactionIds }) {
  const resolvedSelection = selectedTransactionIds && selectedTransactionIds.length > 0 ? selectedTransactionIds : [transactionId];
  return (
    <button type="button" className="h-full text-gray-400 cursor-pointer border border-gray-200 p-2 sm:p-0 rounded-md sm:border-0" onClick={() => showContextMenuInDialog(resolvedSelection)}>
      <div>
        <EllipsisVerticalIcon className="h-5 w-5 sm:h-6 sm:w-6 text-gray-300 sm:text-gray-400 hover:text-gray-500" aria-hidden="true" />
        <span className="sr-only">Transaction context menu</span>
      </div>
    </button>
  );
}
EllipsisButton.propTypes = {
  transactionId: PropTypes.string.isRequired,
  selectedTransactionIds: PropTypes.arrayOf(PropTypes.string),
};
EllipsisButton.defaultProps = {
  selectedTransactionIds: [],
};

function ButtonToggleRowDetail({ value, openDetailRows, toggleDetailRow }) {
  // return a button with chevron icon that toggles the detail row
  return (
    <button type="button" id="toggle-detail-rows" className="hidden pl-1 xs:pl-0 xs:block xs:mr-2 h-full text-gray-400 cursor-pointer" onClick={() => toggleDetailRow(value)}>
      <div>
        {openDetailRows.includes(value) ? (
          <ChevronDownIcon className="h-5 w-5 sm:h-6 sm:w-6 text-gray-400 hover:text-gray-500" aria-hidden="true" />
        ) : (
          <ChevronRightIcon className="h-5 w-5 sm:h-6 sm:w-6 text-gray-400 hover:text-gray-500" aria-hidden="true" />
        )}
        <span className="sr-only">{openDetailRows.includes(value) ? 'Hide details' : 'Show details'}</span>
      </div>
    </button>
  );
}
ButtonToggleRowDetail.propTypes = {
  value: PropTypes.string.isRequired,
  openDetailRows: PropTypes.array.isRequired,
  toggleDetailRow: PropTypes.func.isRequired,
};

function GhostSelectButton({ onSelect, selectionLabel }) {
  return (
    <button
      type="button"
      // eslint-disable-next-line max-len
      className="absolute -ml-1 left-2 top-1/2 -translate-y-1/2 inline-flex h-6 w-6 items-center justify-center rounded border border-gray-200 bg-white text-gray-300 opacity-0 pointer-events-none cursor-pointer transition group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto focus-visible:opacity-100 focus-visible:pointer-events-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200"
      onClick={(event) => {
        event.stopPropagation();
        onSelect();
      }}
      aria-label={selectionLabel}
    >
      <span className="pointer-events-none inline-block h-3.5 w-3.5 rounded-sm border border-gray-300" aria-hidden="true" />
    </button>
  );
}
GhostSelectButton.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectionLabel: PropTypes.string.isRequired,
};

// helper function for formatting strings according to their type
function formatString(str, columnType, currency = null, secondaryCurrency = null, dashWhenNull = false) {
  if (str === undefined || str === null) return dashWhenNull ? '-' : '';

  const resolvedCurrency = currency || 'EUR';
  const resolvedSecondaryCurrency = secondaryCurrency || resolvedCurrency;

  switch (columnType) {
    case 'date':
      return new Date(Number(str)).toLocaleDateString('de', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
      });
    case 'currency0Decimals':
      return str.toLocaleString('de', { style: 'currency', currency: resolvedCurrency, maximumFractionDigits: 0 });
    case 'currency':
      return str.toLocaleString('de', { style: 'currency', currency: resolvedCurrency, maximumFractionDigits: 2 });
    case 'fxCurrency0Decimals':
      return str.toLocaleString('de', { style: 'currency', currency: resolvedSecondaryCurrency, maximumFractionDigits: 0 });
    case 'fxCurrency':
      return str.toLocaleString('de', { style: 'currency', currency: resolvedSecondaryCurrency, maximumFractionDigits: 2 });
    case 'number0Decimals':
      return str.toLocaleString('de', { maximumFractionDigits: 0 });
    case 'number':
      return str.toLocaleString('de', { maximumFractionDigits: 2 });
    case 'percentage':
      return str.toLocaleString('de', { style: 'percent', maximumFractionDigits: 2 });
    case 'boolean':
      return str ? <CheckCircleIcon className="h-5 w-5 inline" /> : <XMarkIcon className="h-5 w-5 inline" />;
    default:
      return String(str);
  }
}

// generates all cells <td> of a row (may have between 1 and 4 values, depending on how tight the layout is)
export function BodyCell({ columns, rowData, rowIndex, colIndex, hidden, toggleDetailRow, openDetailRows, groupByColumn, selectedTransactionIds }) {
  const columnsToRender = columns || [];
  const leadingColumn = columnsToRender[0] || {};
  const highlightThisColumn = columnsToRender.some((x) => (rowData.isSummaryRow || rowData.isTotalRow) && (x.highlight === true || (colIndex === 0 && x.highlight !== false)));

  return (
    <div
      id={`table-row-${rowIndex}-${leadingColumn.id ?? colIndex}`}
      role="cell"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(highlightThisColumn && {
        // if any of the columns is to be highlighted
        onClick: () => {
          if (rowData.isSummaryRow) toggleDetailRow(rowData[groupByColumn]);
        },
      })}
      className={`${hidden}
                 ${leadingColumn.textAlign ? leadingColumn.textAlign : 'text-right'}
                 ${rowData.isSummaryRow || rowData.isTotalRow ? 'font-bold' : ''}
                 ${highlightThisColumn ? 'cursor-pointer' : ''}`}
      //  ${colIndex === 0 ? 'pl-1.5 sm:pl-3' : 'pl-1 sm:pl-2'} py-2 pr-1.5 xs:pr-3 sm:px-4
    >
      {/* insert all the values that belong in this column */}
      {columnsToRender
        // if the column uses isSummaryRowDisplay, filter the column definitions to be displayed in accordance with what the row type is
        .filter((columnDef) => !((rowData.isSummaryRow && columnDef.ifSummaryRowDisplay === false) || (!rowData.isSummaryRow && columnDef.ifSummaryRowDisplay === true)) || rowData.isTotalRow)
        .map((columnDef, indexItemWithinColumn) => (
          <>
            {/* if this is a first item of the first column (with highlight set to true or not set at all, to maintain backward compatibility)
            // or a highlighted column of a summary row, highlight values in blue and display button to toggle row detail below ( label / ellipsis are NOT supported here) */}
            {(rowData.isSummaryRow || rowData.isTotalRow) && (columnDef.highlight === true || (colIndex === 0 && indexItemWithinColumn === 0 && columnDef.highlight !== false)) ? (
              <div className="flex justify-start items-center" key={columnDef.id}>
                {!rowData.isTotalRow && <ButtonToggleRowDetail value={rowData[groupByColumn]} openDetailRows={openDetailRows} toggleDetailRow={toggleDetailRow} />}
                <span className={`${columnDef.classNamesBody || ''} text-brandBlue-500`}>
                  {formatString(rowData[columnDef.id], columnDef.type, rowData.accountCurrency || rowData.currency, rowData.fxCurrency)}
                </span>
              </div>
            ) : (
              <div
                /* handle cases other than first column of a summary row */
                key={columnDef.id}
                // eslint-disable-next-line max-len
                className={`${columnDef.classNamesBoth || ''} ${columnDef.classNamesBody || ''} ${rowData.isSummaryRow ? columnDef.ifSummaryRowclassNames : ''}`}
              >
                {/* check if displayElement has any displayInstead restrictions; otherwise display the actual cell value */}
                {!['label', 'ellipsis'].includes(columnDef.type)
                  && (!columnDef.displayElement?.displayInstead || (columnDef.displayElement?.displayInstead && !rowData[columnDef.displayElement?.displayInsteadWhenField]))
                  && formatString(rowData[columnDef.id], columnDef.type, rowData.assetCurrency || rowData.currency, rowData.fxCurrency, columnDef.dashWhenNull)}

                {/* if displayElement is present, use it to conditionally display element displayElement.element when field displayElement.field is true */}
                {columnDef.displayElement && rowData[columnDef.displayElement.field] && (
                  <columnDef.displayElement.element id={columnDef.id} value={rowData[columnDef.displayElement.field]} rowData={rowData} />
                )}

                {/* if columnDef.type is label or vertical ellpsis, skip formatString and display the required component */}
                {columnDef.type === 'label' && <LabelButton transactionId={rowData.id} label={rowData.label} selectedTransactionIds={selectedTransactionIds} />}
                {columnDef.type === 'ellipsis' && <EllipsisButton transactionId={rowData.id} selectedTransactionIds={selectedTransactionIds} />}
              </div>
            )}
          </>
        ))}
    </div>
  );
}
BodyCell.propTypes = {
  columns: PropTypes.array.isRequired,
  rowData: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  colIndex: PropTypes.number.isRequired,
  hidden: PropTypes.string.isRequired,
  toggleDetailRow: PropTypes.func.isRequired,
  openDetailRows: PropTypes.array.isRequired,
  groupByColumn: PropTypes.string.isRequired,
  selectedTransactionIds: PropTypes.arrayOf(PropTypes.string),
};
BodyCell.defaultProps = {
  selectedTransactionIds: [],
};

// the <tr> element is rendered separately by Virtuoso in Table.jsx
export const TableRow = React.memo(function TableRow({
  index,
  rowObject,
  selectMode,
  isSelected,
  selectionLabel,
  onRowSelect,
  selectedTransactionIds,
  context: { tableLayout, hiddenColumns, toggleDetailRow, openDetailRows, groupByColumn },
}) {
  const layoutColumns = tableLayout?.columns ?? [];
  const rowSelectable = rowObject?.id !== undefined && rowObject?.id !== null;

  const handleCheckboxChange = (event) => {
    if (!rowSelectable) return;
    event.stopPropagation();
    onRowSelect(rowObject.id, index, event);
  };

  return (
    <>
      {selectMode && (
        <div role="cell" className="py-2 flex items-center">
          <input
            type="checkbox"
            className="h-4 w-4 text-brandBlue-600 border-gray-300 rounded focus:ring-brandBlue-500"
            onChange={handleCheckboxChange}
            checked={Boolean(isSelected)}
            disabled={!rowSelectable}
            aria-checked={isSelected}
            aria-label={selectionLabel}
          />
        </div>
      )}
      {layoutColumns.map((columns, colIndex) => (
        // each BodyCell contains between one and usually three fields (div elements), depending on how small the page is
        <BodyCell
          key={`${index}-${colIndex}`}
          rowIndex={index}
          columns={columns}
          rowData={rowObject}
          colIndex={colIndex}
          hidden={hiddenColumns.includes(columns?.[0]?.id) ? 'hidden' : ''}
          toggleDetailRow={toggleDetailRow}
          openDetailRows={openDetailRows}
          groupByColumn={groupByColumn}
          selectedTransactionIds={selectedTransactionIds}
        />
      ))}
      {!selectMode && rowSelectable && <GhostSelectButton onSelect={() => onRowSelect(rowObject.id, index, { forceSelect: true })} selectionLabel={selectionLabel} />}
    </>
  );
});
TableRow.propTypes = {
  index: PropTypes.number.isRequired,
  rowObject: PropTypes.object.isRequired,
  selectMode: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  selectionLabel: PropTypes.string.isRequired,
  onRowSelect: PropTypes.func.isRequired,
  selectedTransactionIds: PropTypes.arrayOf(PropTypes.string),
  context: PropTypes.shape({
    tableLayout: PropTypes.object.isRequired,
    hiddenColumns: PropTypes.array.isRequired,
    toggleDetailRow: PropTypes.func.isRequired,
    openDetailRows: PropTypes.array.isRequired,
    groupByColumn: PropTypes.string.isRequired,
  }).isRequired,
};
TableRow.defaultProps = {
  selectedTransactionIds: [],
};
